import { render, staticRenderFns } from "./AccountActivation.vue?vue&type=template&id=42e1d2d9&scoped=true"
import script from "./AccountActivation.vue?vue&type=script&lang=ts"
export * from "./AccountActivation.vue?vue&type=script&lang=ts"
import style0 from "./AccountActivation.vue?vue&type=style&index=0&id=42e1d2d9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e1d2d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e1d2d9')) {
      api.createRecord('42e1d2d9', component.options)
    } else {
      api.reload('42e1d2d9', component.options)
    }
    module.hot.accept("./AccountActivation.vue?vue&type=template&id=42e1d2d9&scoped=true", function () {
      api.rerender('42e1d2d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccountActivation.vue"
export default component.exports